import * as React from 'react';
import RewardsSwiper from '../RewardsSwiper';
import { CouponRule } from '../types';
import { EcoState } from '../../context';

interface RewardsSectionProps {
    title: string;
    list: CouponRule[];
    swiperKey: string;
    state: EcoState;
    isLogin: boolean;
    ecoState: any;
    setCurrNotes: (notes: any) => void;
    openConfirmModal: (rule: CouponRule) => void;
    customColor?: Record<string, string | undefined>;
    hideAmount?: boolean;
}

/**
 * RewardsSection - Unified section component for displaying reward lists
 * Wraps RewardsSwiper with section title
 */
const RewardsSection: React.FC<RewardsSectionProps> = ({
    title,
    list,
    swiperKey,
    state,
    isLogin,
    ecoState,
    setCurrNotes,
    openConfirmModal,
    customColor,
    hideAmount = false,
}) => {
    // Don't render if list is empty
    if (!list || list.length === 0) return null;

    return (
        <div className={`section ${swiperKey}-section`}>
            <h3 className="section-title">{title}</h3>
            <div className="rule-content">
                <RewardsSwiper
                    list={list}
                    swiperKey={swiperKey}
                    state={state}
                    isLogin={isLogin}
                    ecoState={ecoState}
                    setCurrNotes={setCurrNotes}
                    openConfirmModal={openConfirmModal}
                    customColor={customColor}
                    hideAmount={hideAmount}
                />
            </div>
        </div>
    );
};

export default RewardsSection;
